/**
 * Reading the bundle's `tiers` index (contract, section 2): which tier folder
 * a level and tier number belong to.
 */
import type { Tables } from './types';

/**
 * The tier of a level number and tier number, or null when the tables have
 * none. `variant` picks one of a tier's folders: null is the plain tier, whose
 * hand tables contain those of its variants.
 */
export function tierOf(
  tables: Tables,
  level: number,
  tierNumber: number,
  variant: string | null = null,
): string | null {
  const matching = Object.keys(tables.tiers).filter((tier) => {
    const entry = tables.tiers[tier];
    return (
      entry.level === level && entry.tiers.indexOf(tierNumber) >= 0 && entry.variant === variant
    );
  });
  return matching.length > 0 ? matching[0] : null;
}
